import { c as _c } from "react/compiler-runtime";
import { Vehicle } from '@cruz-com/lookup';
import _ from 'lodash';
import { CruzIcon } from '@/components';
const stylePriceText = 'pr-4 text-sm font-semibold dark:font-normal';
export const Price = t0 => {
  const $ = _c(15);
  const {
    v
  } = t0;
  if (_.isEmpty(v)) {
    return null;
  }
  const price = v?.price || 0;
  if (v.sale_status_id === Vehicle.SaleStatusEnum.Sold) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className={stylePriceText}>Sold</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (price > 0) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <sup className="mr-0.5 pt-2.5 text-base font-medium subpixel-antialiased md:text-sm">$</sup>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== price) {
      t2 = price.toLocaleString();
      $[2] = price;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <span className="font-price text-3xl font-semibold tracking-wide md:text-2xl dark:font-semibold">{t2}</span>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== v.history?.price_change?.value || $[7] !== v.show_price_dropped) {
      t4 = v.show_price_dropped && (v?.history?.price_change?.value || 0) < 0 && <CruzIcon.PriceDrop className="ml-1 size-7 text-red-700" />;
      $[6] = v.history?.price_change?.value;
      $[7] = v.show_price_dropped;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
      t5 = <div className="flex items-center pr-4 antialiased">{t1}{t3}{t4}</div>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  if (v?.user_id) {
    const t1 = v?.sale_status?.name;
    let t2;
    if ($[12] !== t1) {
      t2 = <div className={stylePriceText}>{t1}</div>;
      $[12] = t1;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    return t2;
  }
  let t1;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={stylePriceText}>Price Unknown</div>;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  return t1;
};